import type { ComponentProps } from 'react'

export type ContentImageSource = {
  srcSet: string
  media?: string
  type?: string
}

export type ContentPictureProps = {
  alt?: string
  src: string
  srcs?: ContentImageSource[]
  width?: number
  height?: number
  loading?: ComponentProps<'img'>['loading']
  className?: string
}

export default function ContentPicture({
  alt = '',
  src,
  srcs = [],
  width,
  height,
  loading = 'lazy',
  className
}: ContentPictureProps) {
  return (
    <picture className='block'>
      {srcs.map((source) => (
        <source
          key={`${source.media ?? ''}-${source.srcSet}`}
          media={source.media}
          srcSet={source.srcSet}
          type={source.type}
        />
      ))}
      <img alt={alt} src={src} width={width} height={height} loading={loading} className={className} />
    </picture>
  )
}
